module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand14-f0c67d80867d7b7d545165f3a05729f9.jpg";